import { useEffect } from "react";
import { useSelector } from "react-redux";

import DashboardCategory from "../components/edit/dashboard/DashboardCategory";
import DashboardChannel from "../components/edit/dashboard/DashboardChannel";
import DashboardComments from "../components/edit/dashboard/DashboardComments";
import DashboardLatestCommunity from "../components/edit/dashboard/DashboardLatestCommunity";
import DashboardMembers from "../components/edit/dashboard/DashboardMembers";
import DashboardSales from "../components/edit/dashboard/DashboardSales";

const Dashboard = () => {
	const user = useSelector((state) => state.auth.user);
	// const history = useHistory();

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	// if (user?.id === 1) {
	//     history.replace(`/dashboard/new`);
	// }

	return (
		<div className="main-wrap">
			<div className={`max-width-apply`}>
				<h1 className={`main-title`} id={`main-title`}>
					채널 대시보드
				</h1>
				<div className={`home-dashboard-body`}>
					<div className={`dashboard-left-body`}>
						{/* 판매 실적 */}
						<DashboardSales />
						{/* 최신 게시글 실적 */}
						{user?.id !== 7 && <DashboardLatestCommunity />}
						{/* 최신 댓글 */}
						<DashboardComments />
						{/* 카테고리 분석 */}
						{(user?.id === 7 || user?.id === 9) && <DashboardCategory />}
					</div>
					<div className={`dashboard-right-body`}>
						{/* 채널 분석 */}
						<DashboardChannel />
						{/* 카테고리 분석 */}
						{/*{(user?.id !== 7 && user?.id !== 9) && (*/}
						{/*    <DashboardCategory/>*/}
						{/*)}*/}
						{/* 최근 반응 */}
						<DashboardMembers />
					</div>
				</div>
			</div>
		</div>
	);
};
export default Dashboard;
